import { meta as introducereMeta } from './content/introducere';
import { meta as temaMeta } from './content/tema';
import { meta as contMeta } from './content/cont';
import { meta as abonamenteMeta } from './content/abonamente';
import { meta as facturiMeta } from './content/facturi-si-plati';
import { meta as macheteMeta } from './content/machete';
import { meta as firmeMeta } from './content/firme';
import { meta as generareMeta } from './content/generare-intrastat';
import { meta as faqMeta } from './content/faq';
import { meta as incarcaMeta } from './content/incarca-intrastat';

export const articles = [
  introducereMeta,
  temaMeta,
  contMeta,
  abonamenteMeta,
  facturiMeta,
  macheteMeta,
  firmeMeta,
  generareMeta,
  incarcaMeta,
  faqMeta,
];

export const articlesBySlug = Object.fromEntries(
  articles.map((a) => [a.slug, a])
);
